import axios from "axios";
import store from "../store";
import { REGEX_VALIDATE_EMAIL } from "../../constants/regex";
import { appendBackgroundParam } from "../../utils/query-handling";

// Parse list email (If it is a String separated by ;, convert to list)
const convertEmailList = (inputString) => {
  let listEmail = [];
  if (inputString) {
    if (Array.isArray(inputString)) {
      listEmail = inputString;
    } else if (typeof inputString === 'string') {
      listEmail = inputString.split(';').map(email => email.trim()).filter(email => email.length);
    }
  }
  return listEmail.join(',');
}

const state = {
  // agencyFromEmail: 'householdstaffingjobs@enginehire.io',
  agencyFromEmail: "agency@enginehire.io",
  enginehireFromEmail: "agency@enginehire.io", // If an email is coming from Enginehire (from the platform, as opposed to the agency), this is the email it will come from
  agencyReplyEmail: "",
  enginehireReplyEmail: "aakash@enginehire.ca", // If someone replies to an email from Enginehire, this is where the reply should go
  enginehireAdminEmail: "aakash@enginehire.ca",
  enginehireLoggingEmail: 'enginehirelogs@gmail.com',

  agencyAdminEmail: "aakash@enginehire.io",
  agencyAdminEmail2: "aakash@enginehire.io"
};

const mutations = {
  setAgencyFromEmail(state, payload) {
    state.agencyFromEmail = payload;
  },
  setAgencyReplyEmail(state, payload) {
    state.agencyReplyEmail = payload;
  },
  setAgencyAdminEmail(state, payload) {
    state.agencyAdminEmail = payload;
  },
  setAgencyAdminEmail2(state, payload) {
    state.agencyAdminEmail2 = payload;
  }
};

const actions = {
  setAgencyEmails({ commit }, payload) {
    if (payload.fromEmail && REGEX_VALIDATE_EMAIL.test(payload.fromEmail)) {
      commit("setAgencyFromEmail", payload.fromEmail);
    }
    if (payload.replyEmail && REGEX_VALIDATE_EMAIL.test(payload.replyEmail)) {
      commit("setAgencyReplyEmail", payload.replyEmail);
    }
    if (payload.adminEmail && REGEX_VALIDATE_EMAIL.test(payload.adminEmail)) {
      commit("setAgencyAdminEmail", payload.adminEmail);
      commit("setAgencyAdminEmail2", payload.adminEmail2);
    }
  },
  sendEmail({ commit, dispatch }, emailInfo) {
    console.log(emailInfo);
    // console.log(emailInfo.userID);

    let message = emailInfo.message;
    // If we are sending an html email we want to add the tags and the footer
    if (emailInfo.html) {
      message =
        "<html><head></head><body>" +
        emailInfo.message +
        // '<img src="https://s3-us-west-1.amazonaws.com/trustednannymatch.enginehire.io/Deniz+Hanson_Canva+signature+PNG2.png"></body></html>';
        "</body></html>";
    }
    // Parse list CC (If it is a String separated by ;, convert to list)
    let listCC = convertEmailList(emailInfo.cc);
    // Parse list BCC (If it is a String separated by ;, convert to list)
    let listBcc = convertEmailList(emailInfo.bcc);

    axios
      .post("/optimum/email/", {
        subject: emailInfo.subject,
        // message: emailInfo.message,
        message: message,
        file_urls: emailInfo.file_urls,
        from_address: emailInfo.from,
        to_address: emailInfo.email,
        reply_address: emailInfo.reply || emailInfo.from,
        user_id: emailInfo.userID,
        reference_id: emailInfo.referenceID,
        cc: listCC,
        bcc: listBcc,
        log: true,
        agency_id: store.getters.agencyID,
        type: emailInfo.type
      })
      .then(res => {
        console.log("Email Sent");
        console.log(res);
      })
      .catch(error => console.log(error));
  },
  sendEmailSync({ commit, dispatch }, emailInfo) {
    return new Promise(async (resolve) => {
      console.log(emailInfo);
      // console.log(emailInfo.userID);

      let message = emailInfo.message;
      // If we are sending an html email we want to add the tags and the footer
      if (emailInfo.html) {
        message =
          "<html><head></head><body>" +
          emailInfo.message +
          // '<img src="https://s3-us-west-1.amazonaws.com/trustednannymatch.enginehire.io/Deniz+Hanson_Canva+signature+PNG2.png"></body></html>';
          "</body></html>";
      }
      // Parse list CC (If it is a String separated by ;, convert to list)
      let listCC = convertEmailList(emailInfo.cc);
      // Parse list BCC (If it is a String separated by ;, convert to list)
      let listBcc = convertEmailList(emailInfo.bcc);

      await axios
        .post("/optimum/email/", {
          subject: emailInfo.subject,
          // message: emailInfo.message,
          message: message,
          file_urls: emailInfo.file_urls,
          from_address: emailInfo.from,
          to_address: emailInfo.email,
          reply_address: emailInfo.reply || emailInfo.from,
          user_id: emailInfo.userID,
          reference_id: emailInfo.referenceID,
          cc: listCC,
          bcc: listBcc,
          log: true,
          agency_id: store.getters.agencyID,
          type: emailInfo.type
        });
      resolve();
    });
  },

  sendEmails({ commit, dispatch }, emailInfo) {
    //
    // Send the same email to a list of several emails
    //
    // console.log(emailInfo.emails);
    // console.log(emailInfo.userID);

    // Parse list CC (If it is a String separated by ;, convert to list)
    let listCCOriginal = convertEmailList(emailInfo.cc);
    // Parse list BCC (If it is a String separated by ;, convert to list)
    let listBccOriginal = convertEmailList(emailInfo.bcc);

    for (var emailIndex in emailInfo.emails) {
      if (emailInfo.emails[emailIndex] === state.enginehireLoggingEmail) {
        continue;
      }
      // console.log(emailInfo.emails)
      // console.log(emailIndex)
      // console.log(emailInfo.emails[emailIndex])

      let message = emailInfo.message;
      // If we are sending an html email we want to add the tags and the footer
      if (emailInfo.html) {
        message =
          "<html><head></head><body>" +
          emailInfo.message +
          // '<img src="https://s3-us-west-1.amazonaws.com/trustednannymatch.enginehire.io/Deniz+Hanson_Canva+signature+PNG2.png"></body></html>';
          "</body></html>";
      }

      // Don't use CC, BCC option if sending email to enginehire log
      let listCC = listCCOriginal;
      let listBcc = listBccOriginal;
      let url = "/optimum/email/";
      if (emailInfo.in_background) {
        url = appendBackgroundParam(url);
      }
      axios
        .post(url, {
          subject: emailInfo.subject,
          // message: emailInfo.message,
          message: message,
          file_urls: emailInfo.file_urls,
          from_address: emailInfo.from,
          to_address: emailInfo.emails[emailIndex],
          reply_address: emailInfo.reply || emailInfo.from,
          user_id: emailInfo.userID,
          reference_id: emailInfo.referenceID,
          cc: listCC,
          bcc: listBcc,
          log: true,
          agency_id: store.getters.agencyID,
          type: emailInfo.type,
          status: emailInfo.status,
          countdown: emailInfo.countdown
        })
        .then(res => {
          console.log("Email Sent to " + res.data.email);
        })
        .catch(error => console.log(error));
    }
  },

  logEmail({ commit, dispatch }, emailInfo) {
    console.log("Logging Email");
    console.log(emailInfo);
    console.log(emailInfo.to_address);
    console.log(store.getters.userID);
    if (emailInfo.to_address != state.enginehireAdminEmail && emailInfo.to_address != state.enginehireLoggingEmail) {
      // Don't want to log emails sent to enginehire admin or logging
      axios
        .post("/api/emaillogs/", {
          recipient: emailInfo.user_id,
          sender: store.getters.userID,
          subject: emailInfo.subject,
          body: emailInfo.message,
          to_email: emailInfo.to_address,
          from_email: emailInfo.from_address,
          reply_email: emailInfo.reply_address,
          recipient_name: emailInfo.recipient_name,
          job: emailInfo.job,
          type: emailInfo.type,
          cc: emailInfo.cc,
          bcc: emailInfo.bcc,
          agency_owner: store.getters.agencyName,
          agency: store.getters.agencyID
        })
        .then(res => {
          console.log(res);
          console.log("Email logged!");
        })
        .catch(error => console.log(error));
    }
  },

  // sendAndLogEmail({ commit, dispatch }, emailInfo) {
  //   console.log("Logging Email");
  //   console.log(emailInfo);
  //   console.log(emailInfo.to_address);
  //   console.log(store.getters.userID);
  //   // if (emailInfo.to_address != state.enginehireAdminEmail && emailInfo.to_address != state.enginehireLoggingEmail) {
  //     // Don't want to log emails sent to enginehire admin or logging
  //     axios
  //       // .post("/api/emaillogs/", {
  //       .post("/send-and-log-email/", {
  //         recipient: emailInfo.user_id ? emailInfo.user_id : null,
  //         sender: store.getters.userID ? store.getters.userID : null,
  //         subject: emailInfo.subject ? emailInfo.subject : '',
  //         body: emailInfo.message ? emailInfo.message: '',
  //         to_email: emailInfo.to_address ? emailInfo.to_address : '',
  //         from_email: emailInfo.from_address ? emailInfo.from_address : '',
  //         reply_email: emailInfo.reply_address ? emailInfo.reply_address : '',
  //         recipient_name: emailInfo.recipient_name ? emailInfo.recipient_name : '',
  //         job: emailInfo.job ? emailInfo.job : null,
  //         type: emailInfo.type ? emailInfo.type : '',
  //         agency_owner: store.getters.agencyName ? store.getters.agencyName : '',
  //         agency: store.getters.agencyID ? store.getters.agencyID : null
  //       })
  //       .then(res => {
  //         console.log(res);
  //         console.log("Email Sent and logged!");
  //       })
  //       .catch(error => console.log(error));
  //   // }
  // },

  sendSMS({ commit, dispatch }, SMSInfo) {
    console.log(SMSInfo)
    axios
      .post("/optimum/message/", {
        message: SMSInfo.textMessage,
        phone: SMSInfo.phone,
        user_id: SMSInfo.id,
        from_phone: SMSInfo.from_phone ? SMSInfo.from_phone : "",
        job_id: SMSInfo.jobId,
        log: true
      })
      .then(res => {
        console.log('SMS Sent')
        console.log(res)
      })
      .catch(error => console.log(error))
  },

  // commsAlive() {
  //   console.log('Comms Alive!!')
  // },
  // sendMasivSMS({commit}, SMSInfo) {
  //   console.log('Sending Masiv SMS')
  //   console.log(SMSInfo)

  //   // axios.post('https://api.masiv.co/SmsHandlers/sendhandler.ashx?action=sendmessage&username=Api_5_A73&password=6DZW7HHFQ0&recipient='+SMSInfo.phone+'&originator=3508830809&messagedata='+SMSInfo.message+'&longMessage=true&flash=false&premium=false')
  //   axios.post('https://cors-anywhere.herokuapp.com/https://api.masiv.co/SmsHandlers/sendhandler.ashx?action=sendmessage&username=Api_5_A73&password=6DZW7HHFQ0&recipient='+SMSInfo.phone+'&originator=3508830809&messagedata='+SMSInfo.message+'&longMessage=true&flash=false&premium=false')
  //     .then(res => {
  //       console.log(res)
  //     })
  //     .catch(error => console.log(error))
  // },
};

const getters = {
  agencyFromEmail(state) {
    return state.agencyFromEmail;
  },
  agencyReplyEmail(state) {
    return state.agencyReplyEmail;
  },
  enginehireFromEmail(state) {
    return state.agencyFromEmail;
  },
  enginehireReplyEmail(state) {
    return state.agencyReplyEmail;
  },
  enginehireAdminEmail(state) {
    return state.enginehireAdminEmail;
  },
  enginehireLoggingEmail(state) {
    return state.enginehireLoggingEmail
  },
  agencyAdminEmail(state) {
    return state.agencyAdminEmail;
  },
  agencyAdminEmail2(state) {
    return state.agencyAdminEmail2;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/communication.js